"use strict";

var _regeneratorRuntime = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/regenerator/index.js");

var _defineProperty = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/defineProperty.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elapsedTime = exports.getSessionItem = exports.getFeaturesListDummy = exports.getFeaturesList = void 0;

var axios_1 = __importDefault(require("axios"));

var FeatureToggles_models_1 = require("./FeatureToggles.models");
/**
 * @description - calls the API to get the list of features
 *
 * @param appName - appName from enum
 * @param successResponse - function to call on success
 * @param errorResponse  - function to call on error
 * @param altUrlString -   optional url string to override the default url
 */


var getFeaturesList = function getFeaturesList(appName, successResponse, errorResponse, altUrlString) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var axiosInstance, header, url, _a, status, result, _ref, _ref$status, _status, _ref$statusCode, statusCode, _ref$statusText, statusText, _ref$message, message;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            axiosInstance = axios_1.default.create();
            header = {
              headers: _defineProperty({}, FeatureToggles_models_1.APIM_KEY, "".concat(process.env.GATSBY_APIM_SUBSCRIPTION_KEY))
            };
            _context.prev = 2;
            url = altUrlString ? altUrlString : "".concat(FeatureToggles_models_1.APIUrl).concat(appName);
            _context.next = 6;
            return axiosInstance.get(url, header);

          case 6:
            _a = _context.sent;
            status = _a.status;
            result = __rest(_a, ["status"]);

            if (!(status !== 200)) {
              _context.next = 14;
              break;
            }

            _ref = (result === null || result === void 0 ? void 0 : result.response) || {}, _ref$status = _ref.status, _status = _ref$status === void 0 ? "" : _ref$status, _ref$statusCode = _ref.statusCode, statusCode = _ref$statusCode === void 0 ? null : _ref$statusCode, _ref$statusText = _ref.statusText, statusText = _ref$statusText === void 0 ? "" : _ref$statusText, _ref$message = _ref.message, message = _ref$message === void 0 ? "" : _ref$message;
            throw new Error("".concat(_status || statusCode, " ").concat(statusText || message));

          case 14:
            successResponse(result);

          case 15:
            _context.next = 21;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context["catch"](2);
            console.error("FeatureList Ajax Fail:", _context.t0);
            errorResponse && errorResponse("".concat(_context.t0));

          case 21:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 17]]);
  }));
};

exports.getFeaturesList = getFeaturesList;
/**
 * @description - Fake API  Call to get the list of features
 *
 * @param appName - appName from enum
 * @param successResponse - function to call on success
 * @param errorResponse  - function to call on error
 * @param altUrlString -   optional url string to override the default url
 */

var getFeaturesListDummy = function getFeaturesListDummy(appName, successResponse, errorResponse, altUrlString, doErrorCase) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (doErrorCase) {
              _context2.next = 5;
              break;
            }

            _context2.next = 3;
            return setTimeout(function () {
              var dummyData = {
                features: [{
                  feature: "foo1",
                  enabled: true
                }, {
                  feature: "foo2",
                  enabled: false
                }, {
                  feature: "foo3",
                  enabled: true
                }]
              };
              successResponse(dummyData);
            }, 2000);

          case 3:
            _context2.next = 7;
            break;

          case 5:
            _context2.next = 7;
            return setTimeout(function () {
              var error = new Error("Error Case");
              errorResponse && errorResponse(error);
            }, 2000);

          case 7:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};

exports.getFeaturesListDummy = getFeaturesListDummy;
/**
 * Utility to get session object
 * @param sessionId
 * @returns
 */

function getSessionItem(sessionId) {
  var sessionItemVal = typeof sessionStorage !== "undefined" && sessionStorage.getItem(sessionId);

  if (sessionItemVal !== null) {
    return JSON.parse(sessionItemVal);
  } else {
    return undefined;
  }
}

exports.getSessionItem = getSessionItem;
/**
 *
 * @param dateString
 * @returns
 */

var elapsedTime = function elapsedTime(dateString) {
  var cur = Math.floor(Date.now());
  var last = Math.floor(new Date(dateString).getTime());
  var milliseconds = cur - last;
  var seconds = Math.round(milliseconds / 1000);
  var minutes = Math.round(seconds / 60) || 0;
  return {
    milliseconds: milliseconds,
    seconds: seconds,
    minutes: minutes
  };
};

exports.elapsedTime = elapsedTime;